var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.3487 33.1801C76.5472 31.9329 72.4187 31.4653 69.1912 32.0888C68.8162 28.971 67.0897 26.2432 64.0872 23.8268L62.3609 22.5797L61.1597 24.3725C59.6587 26.7109 58.9081 29.9846 59.1331 33.1024C59.2081 34.1934 59.5834 36.142 60.7094 37.8568C59.6587 38.4804 57.4818 39.2599 54.6297 39.2599H0.360853L0.210853 39.8834C-0.314773 43.001 -0.314773 52.7439 5.84023 60.2264C10.494 65.9162 17.3996 68.8002 26.4818 68.8002C46.1475 68.8002 60.7094 59.3687 67.54 42.2995C70.2422 42.3774 76.0219 42.2995 78.9494 36.4535C79.0244 36.2976 79.1744 35.9858 79.6997 34.8169L80 34.1934L78.3487 33.1801ZM43.7456 11.2002H35.4893V18.9945H43.7456V11.2002ZM43.7456 20.5534H35.4893V28.3477H43.7456V20.5531V20.5534ZM33.9878 20.5534H25.7315V28.3477H33.9878V20.5531V20.5534ZM24.2299 20.5534H15.9734V28.3477H24.2299V20.5531V20.5534ZM14.4721 29.9066H6.21555V37.7009H14.4718V29.9063L14.4721 29.9066ZM24.2299 29.9066H15.9734V37.7009H24.2299V29.9063V29.9066ZM33.9878 29.9066H25.7315V37.7009H33.9878V29.9063V29.9066ZM43.7459 29.9066H35.489V37.7009H43.7459V29.9063V29.9066ZM53.5037 29.9066H45.2468V37.7009H53.5037V29.9063V29.9066Z",
    fill: "#2396ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.9c8bbfeeb5ae9f34db3e87fd74205043.svg";
export { ForwardRef as ReactComponent };